/* eslint-disable max-len */
import 'react';

const PermissionSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <g fill="#5C6373">
                <g fillRule="nonzero">
                    <path d="M11.393 12.741a.709.709 0 01.097 1.411l-.097.007H10.17c-1.904 0-3.41 1.158-3.51 2.54l-.006.15v.617h3.997c.359 0 .655.267.702.613l.007.096a.709.709 0 01-.613.702l-.096.007H5.945a.709.709 0 01-.702-.613l-.007-.096v-1.327c0-2.244 2.12-4.009 4.717-4.103l.217-.004h1.223zM12.56 4.573a3.78 3.78 0 110 7.56 3.78 3.78 0 010-7.56zm0 1.417a2.363 2.363 0 100 4.725 2.363 2.363 0 000-4.725z" />
                </g>
                <path
                    d="M17.285 12.301l2.329 1.345c.292.169.472.48.472.818v2.69c0 .337-.18.649-.472.817l-2.329 1.345a.945.945 0 01-.945 0l-2.329-1.345a.945.945 0 01-.472-.818v-2.689c0-.337.18-.65.472-.818L16.34 12.3a.945.945 0 01.945 0zm-.473 1.146l-2.045 1.18v2.362l2.046 1.18 2.044-1.18v-2.362l-2.044-1.18z"
                    fillRule="nonzero"
                />
                <path d="M16.813 16.728a.945.945 0 100-1.89.945.945 0 000 1.89z" />
            </g>
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
export default PermissionSvg;
